import React, { useState, useEffect, useRef } from 'react';

const ReviewsSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);
  const [isLogoHovered, setIsLogoHovered] = useState(false);
  const sliderRef = useRef(null);
  const animationRef = useRef(null);

  // Testimonial data
  const mainTestimonial = {
    text: "“Working with Timo and the Ayanshtech Solutionsteam was one of the smartest decisions we made for our business. From day one, Timo explained everything clearly and guided us through the entire process with patience and professionalism. He was always available to answer our questions and made the transition smooth and stress-free. The results exceeded our expectations — our monthly infrastructure costs dropped from $1,300 to just $250 while maintaining excellent performance and reliability. This has made a significant difference to our business.”",
    author: {
      name: "Tamika Williams",
      title: "CTO, Aquarion Asset Management, USA",
      avatar: "../assets/images/migration/aleksandr-shuliko-lg-3ea0a954162973cd0cc62f13b47bc170.png",
      companyLogo: "../assets/images/migration/BANDIT2tkk.png"
    },
    tags: ["Cloud Migration", "AWS Exit", "Proxmox", "81% Cost Reduction"]
  };

  // Review cards data
  const reviewCards = [
{
id: 1,
tags: ["Cloud Migration", "AWS", "Infrastructure", "Support"],
text: "Ayanshtech Solutions successfully helped us migrate our infrastructure from AWS to a more cost-effective cloud environment. Their team handled the entire process smoothly, including server setup, database migration, and performance optimization. The migration was completed with minimal downtime, and their ongoing support has been excellent. We highly appreciate their technical expertise and professional approach.",
author: {
name: "Dan Kost",
title: " CEO,DAKDAN Worldwide as a dynamic consultancy and brand-building holding, USA",
avatar: "../assets/images/migration/dankost.jpg",
companyLogo: "https://www.dakdan.com/images/1_dakdan_logo%20-%20Copy.png"
},
isFeatured: false
},
{
id: 2,
tags: ["DevOps", "Automation", "Security", "Monitoring"],
text: "Working with Ayanshtech Solutions has significantly improved our infrastructure management. They implemented automated deployment pipelines, enhanced our server security, and established a reliable monitoring system. Their team is responsive, knowledgeable, and always ready to assist when needed. We are extremely satisfied with the quality of service and would confidently recommend them.",
author: {
name: "Lucky ",
title: "CEO,FMCG - IVCare: The Heart of Care, For Every Life, South Africa ",
avatar: "https://via.placeholder.com/100",
companyLogo: "https://ivcare.co.za/wp-content/uploads/2025/04/Group-12-400x138.png"
},
isFeatured: true
}
];


  // Trusted companies logos for slider
  const trustedCompanies = [
    { name: 'EVADXB', logo: '../assets/images/migration/evadxb-logo.png', url: 'https://evadxb.com/' },
    { name: 'Aphy', logo: '../assets/images/migration/aphy-cca1f01fd637701ef45da1c7d148d695.png', url: '' },
    { name: 'AInergy', logo: '../assets/images/migration/ainergy-logo-bd934fdfab8adc7afe8fe8ee7a15389e.jpg', url:'' },
    { name: 'Boese VA', logo: '../assets/images/migration/boese-va-logo.svg', url: '' }
  ];

  // Duplicate companies for infinite scroll (3 sets)
  const infiniteCompanies = [...trustedCompanies, ...trustedCompanies, ...trustedCompanies];

  // Auto-scroll animation for logos
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    let scrollPosition = 0;
    const speed = 0.5;

    const getSetWidth = () => {
      const firstSet = slider.children[0];
      return firstSet ? firstSet.offsetWidth / 3 : 0;
    };

    const animate = () => {
      if (!isLogoHovered) {
        scrollPosition -= speed;
        const setWidth = getSetWidth();
        
        if (Math.abs(scrollPosition) >= setWidth) {
          scrollPosition = 0;
        }
        
        if (slider) {
          slider.style.transform = `translate3d(${scrollPosition}px, 0px, 0px)`;
        }
      }
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isLogoHovered]);

  const openModal = (review) => {
    setSelectedReview(review);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedReview(null);
  };

  // Modal Component
  const TestimonialModal = () => {
    if (!isModalOpen || !selectedReview) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm" onClick={closeModal}>
        <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8 relative animate-[fadeInUp_0.2s_ease-out]" onClick={(e) => e.stopPropagation()}>
          <button 
            onClick={closeModal}
            className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
            aria-label="Close"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          
          <div className="pr-8">
            <div className="flex flex-wrap items-center gap-1.5 mb-5">
              {selectedReview.tags.map((tag, index) => (
                <span 
                  key={index}
                  className={`inline-flex items-center rounded-full ${index === 0 ? 'border border-gray-200 bg-gray-50 text-green-600' : 'border border-gray-200 bg-gray-50 text-gray-600'} px-2.5 py-1 text-xs font-semibold ${index !== 0 ? 'text-[11px] font-medium' : 'text-xs'}`}
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
          
          <blockquote className="text-gray-700 text-base leading-relaxed italic mb-6 whitespace-pre-line">
            "{selectedReview.text}"
          </blockquote>
          
          <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
              <img src={selectedReview.author.avatar} alt={selectedReview.author.name} className="w-full h-full object-cover" />
            </div>
            <div className="flex-1">
              <p className="font-bold text-gray-900">{selectedReview.author.name}</p>
              <p className="text-sm text-gray-500">{selectedReview.author.title}</p>
            </div>
            <div className="flex-shrink-0 h-8 max-w-[100px]">
              <img src={selectedReview.author.companyLogo} alt="Company Logo" className="h-full w-auto object-contain opacity-70" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section id="reviews" className=" md:py-14 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-4">

        {/* What do our customers say? */}
        <div className="text-center mb-6 md:mb-8">
          <h3 className="text-xl md:text-2xl font-bold text-gray-900">What Our Customers Say</h3>
        </div>
        
        {/* Main Testimonial Card */}
        <div className="grid grid-cols-1 max-w-4xl mx-auto gap-5 mb-8">
          <button 
            type="button" 
            onClick={() => openModal(mainTestimonial)}
            className="bg-white rounded-2xl p-5 md:p-6 text-left cursor-pointer w-full h-full border-2 border-brand-primary/40 shadow-xl ring-1 ring-brand-primary/10 transition-all duration-200 hover:shadow-2xl hover:-translate-y-1 flex flex-col min-h-[280px]"
          >
            <div className="flex items-start justify-between gap-4">
              <div className="flex flex-wrap items-center gap-1.5 mb-4">
                {mainTestimonial.tags.map((tag, index) => (
                  <span 
                    key={index}
                    className={`inline-flex items-center rounded-full ${index === 0 ? 'border border-gray-200 bg-gray-50 text-green-600' : 'border border-gray-200 bg-gray-50 text-gray-600'} px-2.5 py-1 text-xs font-semibold ${index !== 0 ? 'text-[11px] font-medium' : 'text-xs'}`}
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <svg className="w-9 h-9 text-brand-primary/20 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z" />
              </svg>
            </div>
            
            <div className="flex-1 flex items-center my-2 min-h-0">
              <p className="text-gray-700 text-sm md:text-[15px] leading-relaxed italic whitespace-pre-line line-clamp-[6]">
                "{mainTestimonial.text}"
              </p>
            </div>
            
            <div className="pt-4 border-t border-gray-100 flex items-center justify-between gap-4">
              <div className="flex items-center gap-3 min-w-0 flex-1">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-brand-primary/20 bg-gray-100">
                  <img src={mainTestimonial.author.avatar} alt={mainTestimonial.author.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-bold text-gray-900 text-base md:text-lg truncate">{mainTestimonial.author.name}</p>
                  <p className="text-xs md:text-sm text-gray-500 truncate">{mainTestimonial.author.title}</p>
                </div>
              </div>
              <div className="flex-shrink-0 h-7 md:h-8 max-w-[105px]">
                <img src={mainTestimonial.author.companyLogo} alt="EVA Real Estate" className="h-full w-auto object-contain opacity-70" loading="lazy" />
              </div>
            </div>
          </button>
        </div>
        
        {/* Review Cards Grid */}
        <div className="max-w-[1400px] mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
            {reviewCards.map((review) => (
              <button
                key={review.id}
                type="button"
                onClick={() => openModal(review)}
                className={`h-full rounded-xl p-5 flex flex-col text-left cursor-pointer transition-all duration-200 hover:shadow-md hover:-translate-y-0.5 bg-white border ${review.isFeatured ? 'border-2 border-brand-primary/30 shadow-sm ring-1 ring-brand-primary/10' : 'border-gray-200 shadow-sm'}`}
              >
                <div className="flex flex-wrap items-center gap-1.5 mb-4">
                  {review.tags.map((tag, index) => (
                    <span 
                      key={index}
                      className={`inline-flex items-center rounded-full ${index === 0 ? 'border border-gray-200 bg-gray-50 text-green-600' : 'border border-gray-200 bg-gray-50 text-gray-600'} px-2.5 py-1 text-xs font-semibold ${index !== 0 ? 'text-[11px] font-medium' : 'text-xs'}`}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                
                <p className="text-gray-600 text-[13px] leading-relaxed flex-1 line-clamp-6 italic">
                  "{review.text}"
                </p>
                
                <div className="flex items-center gap-3 pt-3 border-t border-gray-100 mt-auto">
                  <div className={`w-9 h-9 rounded-full overflow-hidden flex-shrink-0 bg-gray-200 ${review.isFeatured ? 'ring-2 ring-brand-primary/20' : ''}`}>
                    <img src={review.author.avatar} alt={review.author.name} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="font-semibold text-gray-900 text-sm truncate">{review.author.name}</p>
                    <p className="text-xs text-gray-500 truncate">{review.author.title}</p>
                  </div>
                  <div className="flex-shrink-0 h-6 max-w-[80px]">
                    <img src={review.author.companyLogo} alt="Company Logo" className="h-full w-auto object-contain opacity-60" loading="lazy" />
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
        
      </div>
      
      {/* Modal */}
      <TestimonialModal />
    </section>
  );
};

export default ReviewsSection;